import React from 'react';
import ChatWidget from './ChatWidget';
import SEO from './SEO';
import { breadcrumbSchema } from '../seo/schemas';
import { SiteHeader } from './landing/SiteHeader';
import { Hero } from './landing/Hero';
import { VideoHighlight } from './landing/VideoHighlight';
import { ProjectSlideshow } from './landing/ProjectSlideshow';
import { WhatWeDo } from './landing/WhatWeDo';
import { ChristmasLights } from './landing/ChristmasLights';
import { ServicesGrid } from './landing/ServicesGrid';
import { WhyChooseUs } from './landing/WhyChooseUs';
import { ServiceAreas } from './landing/ServiceAreas';
import { Testimonials } from './landing/Testimonials';
import { ContactSection } from './landing/ContactSection';
import { InstagramSection } from './landing/InstagramSection';
import { ServiceAreaMap } from './landing/ServiceAreaMap';
import { SiteFooter } from './landing/SiteFooter';

const LandingPage = () => (
  <div className="min-h-screen bg-white">
    <SEO
      title="Brooklyn Electrician | 24/7 Emergency & Same-Day Service"
      description="Jetco Electrical — Brooklyn's insured, BBB-accredited electrician for 15+ years. 24/7 emergency repairs, same-day EV charger installation, 200A panel upgrades, generator installs, smart-home wiring & Christmas light installation. Call or text (667) 455-6368 for a free estimate."
      path="/"
      keywords="brooklyn electrician, 24/7 emergency electrician brooklyn, same-day electrician, EV charger installation brooklyn, 200 amp panel upgrade brooklyn, generator installation brooklyn, smart home wiring brooklyn, christmas light installation brooklyn"
      jsonLd={[breadcrumbSchema([{ name: 'Home', path: '/' }])]}
    />
    <SiteHeader />
    <Hero />
    <VideoHighlight />
    <ProjectSlideshow />
    <WhatWeDo />
    <ChristmasLights />
    <ServicesGrid />
    <WhyChooseUs />
    <ServiceAreas />
    <Testimonials />
    <ContactSection />
    <InstagramSection />
    <ServiceAreaMap />
    <SiteFooter />
    <ChatWidget />
  </div>
);

export default LandingPage;
